const cleanValue = (value) => `${value || ''}`.trim()

const getCategoryList = (response) => {
  if (Array.isArray(response)) return response
  if (Array.isArray(response?.brand_categories)) {
    return response.brand_categories
  }
  return []
}

export const mapBrandCategoryResponse = (response) =>
  getCategoryList(response)
    .map((category) => {
      const id = cleanValue(category.id)
      const name = cleanValue(category.name)

      return {
        active: category.active !== false,
        code: cleanValue(category.code),
        createdAt: cleanValue(category.created_at),
        id,
        label: name,
        name,
        updatedAt: cleanValue(category.updated_at),
        value: id,
      }
    })
    .filter(({ id, label }) => Boolean(id && label))

export const getActiveBrandCategories = (categories = []) =>
  categories.filter(({ active }) => active !== false)

export const findMasterBrandCategory = (categories = []) =>
  categories.find(({ code, label }) => {
    const normalizedCode = code.replace(/[\s-]+/g, '_').toUpperCase()
    return (
      normalizedCode === 'MASTER' ||
      normalizedCode === 'MASTER_BRAND' ||
      label.trim().toLowerCase() === 'master brand'
    )
  }) || null
